import { checkProductionMode } from '@provider-portal/common/utils/environment';
import { routerMiddleware } from 'connected-react-router';
import { applyMiddleware, compose, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import { persistStore } from 'redux-persist';
import * as Sentry from '@sentry/react';

import { rootEpic } from 'rdx/epic';
import { AppServices, createMiddleware } from 'rdx/middleware';
import { rootReducer } from 'rdx/reducer';
import { historyInstance } from '@provider-portal/common/utils/history';

const isProductionMode = checkProductionMode();

export const createReduxStore = (appServices: AppServices) => {
  const { allMiddlewares, epicMiddleware } = createMiddleware(appServices);

  let middlewareEnhancers = applyMiddleware(routerMiddleware(historyInstance), ...allMiddlewares);
  if (!isProductionMode) {
    middlewareEnhancers = composeWithDevTools(middlewareEnhancers);
  }

  const sentryEnhancer = Sentry.createReduxEnhancer({
    stateTransformer: () => null,
    actionTransformer: (action) => ({ type: action.type }),
  });
  const store = createStore(
    rootReducer(historyInstance),
    compose(middlewareEnhancers, sentryEnhancer),
  );
  const persistor = persistStore(store);

  epicMiddleware.run(rootEpic);

  return { store, persistor, history: historyInstance };
};
